import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Menu.css';
import LoginIcon from './LoginIcon';
import ContactUsIcon from './ContactUsIcon';
import TermsOfUseIcon from './TermsOfUseIcon';

const Menu = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  // Function to close the menu when a link is clicked
  const closeMenu = () => {
    setShowMenu(false);
  };

  return (
    <div className="menu-container">
      <div className={`menu-icon ${showMenu ? 'open' : ''}`} onClick={toggleMenu}>
        <div className="menu-line"></div>
        <div className="menu-line"></div>
        <div className="menu-line"></div>
      </div>
      <div className={`menu ${showMenu ? 'show' : ''}`}>
        <ul className="menu-items">
          <li>
            <Link to="/" className="menu-link" onClick={closeMenu}>
              <span className="menu-text">Inicio</span>
            </Link>
          </li>
          <li>
            <Link to="/vecinos" className="menu-link" onClick={closeMenu}>
              <span className="menu-text">Vecinos</span>
            </Link>
          </li>
          <li>
            <Link to="/support" className="menu-link" onClick={closeMenu}>
              <span className="menu-text">Ayuda</span>
            </Link>
          </li>
          <li>
            <Link to="/about" className="menu-link" onClick={closeMenu}>
              <span className="menu-text">Nosotros</span>
            </Link>
          </li>
          <li>
            <Link to="/contact" className="menu-link" onClick={closeMenu}>
              <span className="menu-text">Contacto</span>
              <ContactUsIcon />
            </Link>
          </li>
          <li>
            <Link to="/terms" className="menu-link" onClick={closeMenu}>
              <span className="menu-text">Términos</span>
              <TermsOfUseIcon />
            </Link>
          </li>
          <li>
            <Link to="/login" className="menu-link" onClick={closeMenu}>
              <span className="menu-text">Login</span>
              <LoginIcon />
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Menu;
